import React, { useState } from 'react'
import { Col, Form, Modal, Row } from "antd";
import generateAchDetailsPdf from '../../../../../../helpers/generateAchDetailsPdf';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const DownloadAchWireDetails = (props) => {

    const selectedRowsMap = props.selectedRows.reduce((map, account) => {
        const key = account.key;
          map[key] = account;
        return map;
      }, {});

    const [selectedRows, setSelectedRows] = useState(props.tableData.filter((account) => {
        return selectedRowsMap.hasOwnProperty(account.key);
      }))

    const downloadAchWireDetails = async () => {
        for (let acc of selectedRows) {
            if (acc.account.source === 'UN') {
                await generateAchDetailsPdf({
                    beneficiaryName: acc.beneficiary.name || "",
                    beneficiaryAddress: acc.beneficiary.address || "",
                    accountNumber: "",
                    routingNumber: "",
                    accountType: acc.account.account_type || "",
                    bankName: acc.account.bank?.name || "",
                    bankAddress: acc.account.bank_address || "",
                    bankAccountId: acc.id || "",
                });
            }
        }
    };
    

    const deleteRow = (bankAccountId) => {
        
        setSelectedRows((prevState) => {
            const newSelectedRows = prevState.filter((account) => {
                return account.id !== bankAccountId
            })
            return newSelectedRows
        });
    }
      
  return (
    <Modal
        footer={null}
        width={800}
        title="Download ACH/Wire Details"
        visible={props.visible}
        onCancel={props.handleCancelModal}
    >
                <div>
                    <h3 style={{ marginBottom: "18px" }}>
                        Which accounts verification document would you like to download?
                    </h3>

                    <Form
                        onFinish={downloadAchWireDetails}
                    >
                        {selectedRows.map((account) => {
                            return (
                                <Row
                                    gutter={2}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Col
                                        span={8}
                                    >
                                        <Form.Item>{account.description}</Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        {account.account.source === "UN" ? (
                                            <Form.Item>
                                                Ach/Wire details are available
                                            </Form.Item>
                                        ) : (
                                            <Form.Item>
                                                Sorry, Ach/Wire details are only available for Arpari accounts
                                            </Form.Item>
                                        )}
                                    </Col>

                                    <Col
                                        span={4}
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Form.Item>
                                            <Button
                                                disableElevation fullWidth size="small" variant="outlined" color="secondary"
                                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                                                onClick={() => {
                                                    deleteRow(
                                                        account.id
                                                    );
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                style={{ marginTop: "16px" }}
                                disabled={selectedRows.length === 0} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                            >
                                Download ACH/Wire Details
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
  )
}

export default DownloadAchWireDetails